import service from "Utility/Service";
// import { TimestampToDate } from "../../Utility/Fetch";
import { useQuery, useQueryClient, useMutation } from "react-query";
import axios from "axios";
import { AxiosRequestConfig } from "axios";
// import { message } from "antd";
import { ReportList, ReportStatistic, ReportTop, ReportClick } from "Utility/Types/report";
// import { BrokerMessage } from "Utility/Types/alarm_event_notification";
// import { GetSetDevice } from "Utility/Types/status_identity_get_set";
// import { DevicesIdentity } from "Utility/Types/status_identity_get_set";

// ?get_statistic={ "cid": "05bbadc056e947e8a825058e3ec545ad", "name": "ABC", "report": { "filter": { "account_level": { "device": [ "014B100000000001","014B100000000002" ]}, "device_level": {"device": ["014B100000000001", "014B100000000002" ]}},"duration": { "start_utc": 1651334400,"end_utc": 1654012800,"unit": 86400},"parameter":{"account_level":[],"device_level":[]}}}

const getReportStatistic = async (
  props: any,
  loginCid: string,
  stateCid: string,
  level: string
  //@ts-ignore
): Promise<ReportStatistic> => {
  const { account_device, device_device, start_utc, end_utc, unit } = props;

  const cid = level === "super_super" && stateCid !== "" ? stateCid : loginCid;
  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/report_mgnt",
    data: {
      get_statistic: {
        cid,
        report: {
          filter: {
            account_level: { device: account_device },
            device_level: { device: device_device },
          },
          duration: { start_utc, end_utc, unit },
          parameter: { account_level: [], device_level: [] },
        },
      },
    },
  };

  const { data } = await service(config);

  return data;
};

export const useReportStatistic = (props: any, loginCid: string, stateCid: string, level: string) => {
  return useQuery(["reportStatistic", props, stateCid], () => getReportStatistic(props, loginCid, stateCid, level), {
    enabled: Boolean(props.account_device?.length || props.device_device?.length),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createReport = async (props: any) => {
  const {
    // _id,
    name,
    file_name,
    description,
    account_devices,
    device_devices,
    unit,
    periodic,
    custom_periodic,
    report_day,
    demo,
    account_parameter,
    device_parameter,
    duration,
    cid,
    mail_active,
    active,
    company,
    // mail_server,
    // mail_port,
    // mail_from,
    mail_to,
    mail_cc,
    // token,
    customStatus,
  } = props;
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/report_mgnt",
    data: {
      create: {
        // _id,
        active,
        cid,
        name,
        demo,
        file_name,
        description,
        company,
        report: {
          filter: {
            account_level: { device: account_devices },
            device_level: { device: device_devices },
          },
          duration: {
            ...duration,
            // start_utc: 1651334400,
            // end_utc: 1654012800,
            unit,
            default: customStatus === "custom" ? false : true,
            default_report: { periodic, report_day, report_hour: 0 },
            customize_report: { periodic: custom_periodic * 86400 },
          },
          page: {
            account_level: account_parameter,
            device_level: device_parameter,
          },
        },
        mail: {
          active: mail_active,
          // mail_server,
          // mail_port,
          // mail_from,
          mail_to,
          mail_cc,
          // token,
        },
      },
    },
  };

  return service(config);
};

export const useCreateReort = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createReport(props), {
    onSuccess: () => queryClient.invalidateQueries(["reportList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const modifyReport = async (props: any) => {
  const {
    _id,
    name,
    file_name,
    description,
    account_devices,
    device_devices,
    unit,
    periodic,
    custom_periodic,
    report_day,
    demo,
    account_parameter,
    device_parameter,
    duration,
    cid,
    active,
    mail_active,
    company,
    // mail_server,
    // mail_port,
    // mail_from,
    mail_to,
    mail_cc,
    // token,
    customStatus,
  } = props;
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/report_mgnt",
    data: {
      modify: {
        active,
        _id,
        cid,
        name,
        demo,
        file_name,
        description,
        company,
        report: {
          filter: {
            account_level: { device: account_devices },
            device_level: { device: device_devices },
          },
          duration: {
            ...duration,
            unit,
            default: customStatus === "custom" ? false : true,
            default_report: { periodic, report_day, report_hour: 0 },
            customize_report: { periodic: custom_periodic * 86400 },
          },
          page: {
            account_level: account_parameter,
            device_level: device_parameter,
          },
        },
        mail: {
          active: mail_active,
          // mail_server,
          // mail_port,
          // mail_from,
          mail_to,
          mail_cc,
          // token,
        },
      },
    },
  };

  return service(config);
};

export const useModifyReort = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => modifyReport(props), {
    onSuccess: () => queryClient.invalidateQueries(["reportList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteReport = async (props: any) => {
  const { name, cid, _id, delete_pdf, file_name } = props;
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/report_mgnt",
    data: {
      delete: {
        _id,
        cid,
        name,
        file_name,
        delete_pdf,
      },
    },
  };

  return service(config);
};

export const useDeleteReort = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteReport(props), {
    onSuccess: () => queryClient.invalidateQueries(["reportList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getReportList = async (cid: string): Promise<ReportList> => {
  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/report_mgnt",
    data: {
      list: { cid },
    },
  };

  const { data } = await service(config);

  return data;
};

export const useReportList = (cid: string, stateCid: string) => {
  return useQuery(["reportList", stateCid], () => getReportList(cid), {
    // enabled: Boolean(props.account_device.length || props.device_device.length),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface Top {
  filterForm: any;
  loginCid: string;
  stateCid: string;
  level: string;
  // limit?: number;
  type: keyof typeof sort;
}

const sort = {
  health_top: { offline: 1, critical: 1, warning: 1 },
  signal_top: { poor: 1, fair: 1, good: 1 },
  cellular_top: { tx_rx: 1 },
  wan_top: { tx_rx: 1 },
};

const getReportTop = async ({ filterForm, loginCid, stateCid, level, type }: Top): Promise<ReportTop> => {
  const { account_device, start_utc, end_utc } = filterForm;

  const cid = level === "super_super" && stateCid !== "" ? stateCid : loginCid;
  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/report_mgnt",
    data: {
      get_top: {
        cid,
        device: account_device,
        duration: { start_utc: start_utc, end_utc: end_utc },
        tops: [{ type: type, limit: 9999, sort: sort[type] }],
      },
    },
  };

  const { data } = await service(config);

  return data;
};

export const useReportTop = ({ filterForm, loginCid, stateCid, level, type }: Top) => {
  return useQuery(
    ["ReportTop", filterForm, type, stateCid],
    () => getReportTop({ filterForm, loginCid, stateCid, level, type }),
    {
      enabled: Boolean(filterForm.account_device?.length),
    }
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getInstanceReport = async (props: any) => {
  const {
    _id,
    name,
    file_name,
    demo,
    account_devices,
    device_devices,
    unit,
    duration,
    account_parameter,
    device_parameter,
    periodic,
    custom_periodic,
    report_day,
    description,
    cid,
    report,
    mail_active,
    // active,
    mail,
    // mail_server,
    // mail_port,
    // mail_from,
    mail_to,
    mail_cc,
    // token,
    customStatus, //not a good method to judge if period is custom
  } = props;

  let config: AxiosRequestConfig = {
    method: "post",
    url: "/report_mgnt",
    responseType: demo ? "blob" : "json",
    data: {
      get_report: {
        _id,
        cid,
        name,
        file_name,
        demo,
        description,
        report: report ?? {
          filter: {
            account_level: { device: account_devices },
            device_level: { device: device_devices },
          },
          duration: {
            ...duration,
            // start_utc: 1651334400,
            // end_utc: 1654012800,
            unit,
            default: customStatus === "custom" ? false : true,
            default_report: { periodic, report_day, report_hour: 0 },
            customize_report: { periodic: custom_periodic * 86400 },
          },
          page: {
            account_level: account_parameter,
            device_level: device_parameter,
          },
        },
        mail: mail ?? {
          active: mail_active,
          // mail_server,
          // mail_port,
          // mail_from,
          mail_to,
          mail_cc,
          // token,
        },
      },
    },
  };
  return service(config);
};

export const useInstanceReport = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => getInstanceReport(props), {
    onSuccess: () => queryClient.invalidateQueries(["reportList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getReportClick = async (props: any): Promise<ReportClick> => {
  const { level, stateCid, account_devices, loginCid, duration } = props;

  let cid = loginCid;
  if (level === "super_super" && stateCid !== "") {
    cid = stateCid;
  } else if (level !== "super_super") {
    cid = loginCid;
  }

  let config: AxiosRequestConfig = {
    method: "post",
    url: "/report_mgnt",
    data: {
      get_health_signal_statistic: {
        cid,
        report: {
          filter: {
            account_level: {
              device: account_devices,
            },
          },
          duration,
        },
      },
    },
  };

  const { data } = await service(config);

  return data;
};

export const useReportClick = () => {
  // const queryClient = useQueryClient();
  return useMutation((props: any) => getReportClick(props), {
    // onSuccess: () => queryClient.invalidateQueries(["reportList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const uploadTemplateLogo = (param: any) => {
  const { cid, fileList, file_name } = param;
  const formData = new FormData();
  formData.append("file", fileList[0].originFileObj);

  const UploadUrl = `/repository?upload_file={"cid":"${cid}","name":"${file_name}.logo","type":"REPORT","inf": {}}`;
  return service.post(UploadUrl, formData);
};

export const useUploadLogo = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => uploadTemplateLogo(param), {
    onSuccess: () => queryClient.invalidateQueries(["repositoryList", stateCid]),
  });
};
